import { Link, useLocation } from "react-router-dom";
import "../BinTransfer/BinTransferMain.css";
import { ArrowForwardIos } from "@mui/icons-material";
function Breadcrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="mt-1 mb-1 ">
      {vPathName === "/VendorDiscontinueChangeRequest" ? (
        <div>
          <span
            className="breadcrumb-not-active "
            //  style={{ fontSize: '1rem', textDecorationLine: 'underline' }}
          >
            Masters{" "}
          </span>{" "}
          <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
          <span
            className="breadcrumb-not-active "
            //  style={{ fontSize: '1rem', textDecorationLine: 'underline' }}
          >
            Vendor Discontinue Request{" "}
          </span>
        </div>
      ) : vPathName === "/VendorDiscontinueChangeRequestDetail" ? (
        <div className="d-flex align-items-center">
          {" "}
          <span
            className="breadcrumb-not-active "
            //  style={{ fontSize: '1rem', textDecorationLine: 'underline' }}
          >
            Masters{" "}
          </span>{" "}
          <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
          <Link
            to="/VendorDiscontinueChangeRequest"
            state={location}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={"breadcrumb-active mr-2"}
          >
            Vendor Discontinue Request
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
          <div>
            <span
              className="breadcrumb-not-active"
              //  style={{ fontSize: '0.85rem', textDecorationLine: 'underline' }}
            >
              Vendor Discontinue Detail
            </span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
export default Breadcrumbs;
